//////LIBRARY//////
import { cloneDeep, find, isEmpty, isEqual, isUndefined } from 'lodash'
import React, { Fragment, useEffect, useState, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import styled from 'styled-components'
//////COMPONENTS//////
import ActionsTable from '../../components/ActionsTable/ActionsTable'
import DropdownCheckbox from '../../components/DropdownCheckbox'
import Modals from '../../components/Modals'
import Table from '../../components/Table'
import Tooltip from '../../components/Tooltip/Tooltip'
import Button from '../../components/Ui/Buttons'
import userPrivileges from '../../constants/PrivilegesList'
import UseCheckAll from '../../hooks/UseCheckAll'
import { uriList } from '../../routings/settings/RouteList'
import { usersManagerActionCreators, columnsActionCreators, tableActionCreators } from '../../store/actions'
import { selectIdsUser } from '../../store/selectors/user'
import { ButtonWrapper, TextModal, TableHeaderCreateButton } from '../../theme/GlobalCss'
import Theme from '../../theme/theme'
import DivisionColumn from './Components/DivisionColumn'
import { UsersManagerEnableComponent, UsersManagerTagsComponent } from './Components'
import TableTitle from '../../components/Table/components/TableTitle'
//////ASSETS//////
import Close from '../../assets/icones/global/close-white.svg'

//////STYLED//////
const UsersManagerWrapper = styled.div`
	position: relative;
`
//////STYLED//////

const UsersManager = () => {
	let history = useHistory()

	const [showModal, setShowModal] = useState(false)
	const [row, setRow] = useState({})
	const [paging, setPaging] = useState({
		page: '0',
		size: '250',
		sort: 'companyTyped.company.labelToDisplay',
		nameDir: 'asc',
		sort_2: 'companyTyped.companyType.translationKey',
		nameDir_2: 'asc',
		sort_3: 'lastName',
		nameDir_3: 'asc',
	})
	const [configTable, setConfigTable] = useState({})
	const [configTableTitle, setConfigTableTitle] = useState({
		actions: {},
		paging: {
			fnSendTo: (paging) => handlePagingUsersManager(paging),
		},
	})

	// Search bar
	const [searchValue, setSearchValue] = useState()

	// Filters
	const [prevFilter, setPrevFilter] = useState({})
	const [filters, setFilters, handleCheckElements] = UseCheckAll(prevFilter)

	// Columns
	const [columns, setColumns] = useState([])

	const {
		user,
		translations,
		usersManager,
		usersManagerFilters,
		deleteSuccess,
		userRoleLevel,
		currentUser,
		isSearchfieldUpdated,
		currentColumn,
		currentDir,
	} = useSelector(
		(state) => ({
			user: state.user,
			currentUser: selectIdsUser(state),
			translations: state.languages.translations,
			usersManager: state.usersManager,
			usersManagerFilters: state.usersManager.header,
			deleteSuccess: state.usersManager.deleteSuccess || false,
			userRoleLevel: state.user.identity.rolePrivileges.role.level,
			isSearchfieldUpdated: state.columns.isSearchfieldUpdated,
			currentColumn: state.columns.currentColumn,
			currentDir: state.columns.currentDir,
		}),
		shallowEqual
	)

	const actionsUserManager = bindActionCreators(usersManagerActionCreators, useDispatch())
	const actionsColumns = bindActionCreators(columnsActionCreators, useDispatch())
	const actionsTable = bindActionCreators(tableActionCreators, useDispatch())

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handlePagingUsersManager = (paging) => {
		let sortMap = {}
		if (!isUndefined(currentColumn.value)) {
			sortMap = {
				sort: currentColumn.value,
				nameDir: currentDir.value,
			}
		} else {
			sortMap = {
				sort: 'companyTyped.company.labelToDisplay',
				nameDir: 'asc',
				sort_2: 'companyTyped.companyType.translationKey',
				nameDir_2: 'asc',
				sort_3: 'lastName',
				nameDir_3: 'asc',
			}
		}
		const pg = { ...paging, ...sortMap }
		setPaging(pg)
		actionsUserManager.getAdminUsers(filters, pg)
	}

	const handleModal = (dataRow) => {
		setRow({ ...dataRow })
		setShowModal((prevState) => !prevState)
	}

	const deleteUserHandler = (scope) => {
		actionsUserManager.deleteAdminUser(row.id, scope)
		handleModal()
	}
	// handler search bar

	const handleSearchEnter = (e, val) => {
		if (e.keyCode !== 13) return
		setSearchValue(val)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleClickSearch = (refInput) => {
		setSearchValue(refInput.current.value)
		actionsColumns.setIsSearchfieldUpdated(true)
	}

	const handleSubmit = () => {
		if (isEqual(filters, prevFilter)) return // guard to call if no change
		setPrevFilter(filters)

		// Force reset paging at zero, in case when filters are preventing any pagination with current size
		let pg = cloneDeep(paging)
		if (isUndefined(pg)) {
			pg = {
				page: '0',
				size: '250',
				sort: 'companyTyped.company.labelToDisplay',
				nameDir: 'asc',
				sort_2: 'companyTyped.companyType.translationKey',
				nameDir_2: 'asc',
				sort_3: 'lastName',
				nameDir_3: 'asc',
			}
		} else {
			pg.page = '0'
		}
		setPaging(pg)

		actionsUserManager.getAdminUsers(handleFilterSend(), pg)
	}

	const handleFilterSend = () => {
		const filtersIn = cloneDeep(filters)
		let searchFieldUpdated = {}
		let filtersOut = {}

		if (isSearchfieldUpdated) {
			searchFieldUpdated = {
				searchFieldUpdated: true,
			}
		} else {
			searchFieldUpdated = {
				searchFieldUpdated: false,
			}
		}
		filtersOut = { ...searchFieldUpdated, ...filtersIn }
		return {
			...filtersOut,
			withFilters: true,
		}
	}

	const handlerLogRedirect = (row) => {
		history.push(`${uriList.log}${uriList.logUserManager}`)
		actionsUserManager.setUserLogin(row)
	}

	const handleEditUser = (row) => {
		const isCurrentUser = currentUser.userId === row.id
		history.push(
			isCurrentUser
				? `${uriList.myAccount}${uriList.myAccountEdit}`
				: `${uriList.users}${uriList.usersManager}${uriList.usersManagerEdit}/${row.id}`
		)
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		setColumns([
			{
				columnReferential: 'userManager_companyName',
				dataHook: 'companyName',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_company'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'companyTyped.company.labelToDisplay',
			},
			{
				columnReferential: 'userManager_companyType',
				dataHook: 'companyType.translationKey.translationKey',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_division'],
				toMapObject: true,
				toTranslate: true,
				sortable: true,
				isAuthorize: true,
				component: DivisionColumn,
				sortableId: 'companyTyped.companyType.translationKey.id',
			},
			{
				columnReferential: 'userManager_fullName',
				dataHook: 'fullName',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_name'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'lastName',
			},
			{
				columnReferential: 'userManager_login',
				dataHook: 'login',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_username'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'username',
			},
			{
				columnReferential: 'userManager_email',
				dataHook: 'email',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_email'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'email',
			},
			{
				columnReferential: 'userManager_role',
				dataHook: 'role.label',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_role'],
				sortable: true,
				isAuthorize: true,
				toMapObject: true,
				sortableId: 'roles.name',
			},
			{
				columnReferential: 'userManager_roleLevel',
				dataHook: 'roleLevel',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_level'],
				sortable: true,
				isAuthorize: true,
				component: (props) => {
					return 'Niveau ' + props.row.roleLevel
				},
				sortableId: 'roles.level',
			},
			{
				columnReferential: 'userManager_companyService',
				dataHook: 'companyService.translationKey',
				headerName: translations['page__userManagement__userTable_tableHeader_service'],
				sortable: true,
				isAuthorize: true,
				sortableId: 'SC.label',
			},
			{
				columnReferential: 'userManager_activate',
				dataHook: 'enabled',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_isActive'],
				sortable: true,
				isAuthorize: true,
				component: UsersManagerEnableComponent,
				useCustomSkeleton: true,
				sortableId: 'isEnabled',
			},
			{
				columnReferential: 'userManager_tags',
				dataHook: 'tags',
				headerName: translations['page__userManagement__admin__userTable__tableHeader_tag'],
				//sortable: true,
				isAuthorize: true,
				component: UsersManagerTagsComponent,
			},
			{
				action: true,
				isFixed: true,
				component: ActionsTable,
				withIcons: false,
				rest: {
					tooltipPart: 'usersManager',
					paperActionsList: [
						{
							name: translations['tooltip__admin__userManagement__tableAction__userLogHistory'],
							//iconDef: logRedirect,
							translationKey: 'tooltip__admin__userManagement__tableAction__userLogHistory',
							clickAction: (row) => {
								handlerLogRedirect(row.login)
							},
							isVisible: () => true,
						},
						{
							//iconDef: edit,
							name: translations['tooltip__admin__userManagement__tableAction__updateUser'],
							translationKey: 'tooltip__admin__userManagement__tableAction__updateUser',
							clickAction: (row) => {
								handleEditUser(row)
							},
							isVisible: (row) => row.roleLevel >= userRoleLevel,
						},
						{
							translationKey: 'tooltip__admin__userManagement__tableAction__deleteUser',
							name: translations['tooltip__admin__userManagement__tableAction__deleteUser'],
							clickAction: (row) => {
								handleModal(row)
							},
							isVisible: (row) => row.roleLevel >= userRoleLevel,
							//icon: deleteImg,
						},
					],
				},
				checkRight: userPrivileges.action[10],
			},
		])
	}, [translations])

	// Used for columns displaying (redux stored)
	const tableReferential = {
		idPageTable: 14,
		labelPageTable: 'userManager',
	}

	useEffect(() => {
		const cfg = cloneDeep(configTableTitle)
		if (!isEmpty(usersManager) && !isUndefined(usersManager)) {
			cfg.paging = {
				totalElements: usersManager.paging.totalElements,
				totalPages: usersManager.paging.totalPages,
				fnSendTo: (paging) => handlePagingUsersManager(paging),
			}
			setConfigTableTitle(cfg)
		}
	}, [usersManager])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.name = translations['page__userManagement__admin__userTable__title']

		cfg.actions.rest = [
			() => (
				<DropdownCheckbox
					title={translations['page__userManagement__filters_companyTypes']}
					data={filters.filtersSelection?.companyTypeds.filterElements || []}
					translations={translations}
					toTranslate={true}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'companyTypeds'}
				/>
			),
			() => (
				<DropdownCheckbox
					title={translations['page__userManagement__filters_companies']}
					data={filters.filtersSelection?.companies.filterElements || []}
					translations={translations}
					paperTopPosition={'40'}
					dropColor={'blueColor'}
					selectActionsHandler={handleCheckElements}
					submitOnClose={handleSubmit}
					target={'companies'}
				/>
			),
		]

		cfg.paging = {
			totalElements: usersManager.paging.totalElements,
			totalPages: usersManager.paging.totalPages,
			fnSendTo: (paging) => handlePagingUsersManager(paging),
		}

		setConfigTableTitle(cfg)
	}, [filters, translations])

	useEffect(() => {
		let cfg = cloneDeep(configTableTitle)

		cfg.actions.searchBarComponent = {
			handleSearchEnter: handleSearchEnter,
			handleClickSearch: handleClickSearch,
			placeholder: translations['common__text__fastFilter_search'],
			defaultValue: searchValue,
			handleReset: (refInput) => {
				refInput.current.value = ''
				setSearchValue('')
			},
		}

		setConfigTableTitle(cfg)
	}, [searchValue])

	const [swytch, setSwytch] = useState(false)

	useEffect(() => {
		if (!isUndefined(user) || !isEmpty(searchValue)) {
			setSwytch(true)
		}
	}, [user, searchValue])

	useEffect(() => {
		if (isUndefined(user) || isEmpty(translations)) return
		if (swytch) {
			const filtersCp = {
				withFilters: false,
				filtersSelection: null,
				searchField: searchValue,
				searchFieldUpdated: searchValue?.length > 0 ? true : false,
			}
			actionsUserManager.getAdminUsers(filtersCp)
			actionsColumns.setColumns([])
			setConfigTable({ ...configTable, export: { bd: filtersCp } })
			setFilters(filtersCp)
		}
	}, [swytch, translations])

	useEffect(() => {
		// If we came from redirection
		if (!isEmpty(usersManager.companyId)) {
			setSearchValue(usersManager.companyId.labelToDisplay)
			let filtersCP = cloneDeep(filters)
			filtersCP.searchField = usersManager.companyId.labelToDisplay
			setFilters(filtersCP)
		}
	}, [usersManager.companyId])

	useEffect(() => {
		return function cleanUp() {
			actionsUserManager.resetDataUsersManager()
			actionsTable.resetPaggingConfig()
		}
	}, [])

	useEffect(() => {
		if (!deleteSuccess) return
		actionsUserManager.getAdminUsers(handleFilterSend(), paging)
	}, [deleteSuccess])

	useEffect(() => {
		const filtersCp = cloneDeep(usersManagerFilters)
		filtersCp.withFilters = true
		setFilters(filtersCp)
		setPrevFilter(filtersCp)
	}, [usersManagerFilters])

	useEffect(() => {
		const filtersCP = cloneDeep(filters)
		filtersCP.searchField = searchValue
		setFilters(filtersCP)
	}, [searchValue])

	useEffect(() => {
		if (filters.searchField !== searchValue || searchValue === usersManager.companyId.labelToDisplay) return
		handleSubmit()
	}, [filters.searchField])

	///////////////////////////////// RENDER ///////////////////////////////////////

	const TableRender = useMemo(() => {
		return (
			<Table
				inputColumns={columns}
				inputData={usersManager.items}
				inputConfig={configTable}
				currentPaging={paging}
				isLoading={usersManager.isLoading}
				tableReferential={tableReferential}
				actionSort={actionsUserManager.getAdminUsers}
			/>
		)
	}, [usersManager, columns, translations, configTable, paging])

	return (
		<Fragment>
			<Modals
				title={translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_title']}
				closeModalHandler={handleModal}
				showModal={showModal}
				level="error"
				icon={true}
			>
				<TextModal>
					<p>{translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_body']}</p>
				</TextModal>
				<ButtonWrapper>
					<Button
						actionHandler={handleModal}
						text={translations['common__text__cancel']}
						bgColor={Theme.colors.error}
						margin="true"
						img={Close}
					/>

					<Button
						actionHandler={() => deleteUserHandler('disable')}
						text={translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_button_disableUser']}
						bgColor={Theme.colors.warning}
						margin="true"
						disabled={!row.enabled}
					/>

					<Button
						actionHandler={() => deleteUserHandler('delete')}
						text={translations['page__userManagement__userTable_modalAction_deleteUser_modalChooseDeletionType_button_deleteUser']}
						color={Theme.colors.error}
						bgColor={Theme.colors.white}
						borderColor={Theme.colors.error}
					/>
				</ButtonWrapper>
			</Modals>
			<UsersManagerWrapper>
				{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[10])) && (
					<Tooltip tooltipId={'addButton'} translationsKey={'tooltip__admin__userManagement__createUser'}>
						<TableHeaderCreateButton to={`${uriList.users}${uriList.usersManager}${uriList.usersManagerCreate}`} />
					</Tooltip>
				)}

				{!isUndefined(translations) && !isUndefined(configTableTitle) && (
					<TableTitle inputConfig={configTableTitle} inputColumns={columns} tableReferential={tableReferential} />
				)}
				{!isUndefined(translations) && !isUndefined(configTable) && TableRender}
			</UsersManagerWrapper>
		</Fragment>
	)
}

UsersManager.propTypes = {}

UsersManager.defaultPropTypes = {}

export default UsersManager
